<template>
  <div class="pt-4">
    <div class="slider-component">
      <div class="slidecontainer">
        <span :style="{width: currentValue + '%'}">
          <label>{{currentValue}}</label>
        </span>
        <input
          ref="input"
          v-model="currentValue"
          type="range"
          :min="min"
          :max="max"
          class="slider"
          @input="onInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSlider',
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  data(){
    return {
      currentValue: this.value
    };
  },
  methods: {
    onInput() {
      // this.currentValue is a string because HTML is weird
      this.$emit('input', parseInt(this.currentValue));
    }
  }
};
</script>

<style lang="scss" scoped>
.slider{
  background: #fff;
  .slider-component {
    .slidecontainer {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      span{
        height: 4px;
        background: #3b7ef1;
        position: absolute;
        top: 0;
        border-radius: 3px;
        label{
          position: absolute;
          right: 0;
          transform: translateX(50%);
          bottom: 100%;
          padding: 3px 6px;
          background: #3b7ef1;
          border-radius: 3px;
          font-size: 11px;
          line-height: 13px;
          color: #fff;
          font-weight:600;
          box-shadow: 0 1px 5px rgba(0,0,0,0.2);
          display: inline-block;
          margin-bottom: 12px;
          &:after{
            position: absolute;
            content: '';
            border-top: 4px solid #3b7ef1;
            border-right: 4px solid transparent;
            border-left: 4px solid transparent;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      .slider {
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        height: 5px;
        border-radius: 3px;
        background: rgba(59, 126, 241, 0.3);
        outline: none;
        margin: 0;
        position: relative;
        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 15px;
          height: 15px;
          border: 1px solid #3b7ef1;
          background: #fff;
          cursor: pointer;
          border-radius: 50%;
          position: relative;
          z-index: 2;
        }
        &::-moz-range-thumb {
          width: 15px;
          height: 15px;
          border: 1px solid #3b7ef1;
          background: #fff;
          cursor: pointer;
          border-radius: 50%;
        }
        &:after{
          width: 15px;
          height: 15px;
          border-radius: 50%;
          border: 1px solid #3b7ef1;
          background: #fff;
          right: 0;
          top: -5px;
          position: absolute;
          content: '';
        }
      }
    }
  }
}
</style>